import * as React from 'react';

interface IBackButtonProps {
  onClick?: () => void;
  label?: string;
}

export default class BackButton extends React.Component<IBackButtonProps, {}> {
  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick();
    } else {
      // Default: go back in browser history
      window.history.back();
    }
  };

  render() {
    const label = this.props.label || 'Back';
    return (
      <button 
        type="button" 
        className="btn btn-default" 
        onClick={this.handleClick}
        style={{ marginBottom: '15px' }}
      >
        <span aria-hidden="true">←</span> {label}
      </button>
    );
  }
}
